<template>
  <div
    v-if="insuranceLoaded"
    class="ad-price__text-link"
    @click.prevent="insuranceJumplinktrigger()"
  >
    Forsikring
  </div>
</template>

<script>
import { app } from '@/main'

import { AdPriceInsuranceClicked } from '@/events'

export default {
  props: {},
  data() {
    return {
      insuranceLoaded: false,
    }
  },
  methods: {
    insuranceModuleLoaded() {
      this.insuranceLoaded = true
    },
    insuranceJumplinktrigger() {
      app.mitt.emit('insurance-jumplink-triggered')

      AdPriceInsuranceClicked()
    },
  },
  created() {
    app.mitt.on('insurance-module-loaded', this.insuranceModuleLoaded)
  },
}
</script>
